module.exports = __webpack_public_path__ + "media/images/ecute/ecutetokyo_ko_PC-f95e40c2ee4c1cd142e240e134755d9a.jpg";